import { BadgeCheck } from 'lucide-react'
import type { VerificationStatus } from '../types/api'

/**
 * The one mark that sets a verified provider apart. Unverified providers are listed too, so this
 * badge - shown only for VERIFIED, never for a tier left over from an earlier approval - is what a
 * learner looks for.
 */
export function VerifiedBadge({ status, size = 'sm' }: { status: VerificationStatus | undefined; size?: 'xs' | 'sm' }) {
  if (status !== 'VERIFIED') return null
  return (
    <span
      title="Verified by the YellowDots team"
      className={`inline-flex shrink-0 items-center gap-1 rounded-full bg-emerald-100 font-semibold text-emerald-700 ${
        size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs'
      }`}
    >
      <BadgeCheck size={size === 'xs' ? 10 : 12} aria-hidden="true" /> Verified
    </span>
  )
}
